import { stripHtml } from 'string-strip-html'

const removeHtmlTags = (htmlText: string) => {
  if (!htmlText) return null

  return stripHtml(htmlText).result
}

export { removeHtmlTags }
